import { Injectable, signal } from '@angular/core';

import { Geometry } from '@connect-services/src/sdk/api';

export type GeometryEditPreview = {
    after: Geometry;
    before: Geometry;
    businessIdentifier: { key: string; value: unknown };
    entityId: string;
    layerId: string;
    tableName: string;
};

@Injectable({
    providedIn: 'root',
})
export class GeometryEditPreviewService {
    private readonly previews = signal<Record<string, GeometryEditPreview>>({});

    public clear(layerId: string, entityId: string): void {
        this.previews.update((previews: Record<string, GeometryEditPreview>) => {
            const nextPreviews = { ...previews };

            delete nextPreviews[this.buildKey(layerId, entityId)];

            return nextPreviews;
        });
    }

    public get(layerId: string, entityId: string): GeometryEditPreview | undefined {
        return this.previews()[this.buildKey(layerId, entityId)];
    }

    public getGeometry(layerId: string, entityId: string): Geometry | undefined {
        return this.get(layerId, entityId)?.after;
    }

    public set(preview: GeometryEditPreview): void {
        this.previews.update((previews: Record<string, GeometryEditPreview>) => ({
            ...previews,
            [this.buildKey(preview.layerId, preview.entityId)]: preview,
        }));
    }

    private buildKey(layerId: string, entityId: string): string {
        return `${layerId}:${entityId}`;
    }
}
